<div class="modal-wrapper sm:max-w-md md:max-w-lg">

    <div class="flex items-center justify-between">
        <div>
            <h3 class="modal-title text-start!">
                {{'USER_MANAGEMENT.REJECT_USER_ACCOUNT' | translate}}</h3>
            <p class="text-base text-(--text-muted) mt-1 text-start">
                {{ 'USER_MANAGEMENT.REJECT_USER_REASON_REQUIRED' | translate }}
            </p>
        </div>

        <!-- Cancel Icon -->
        <img src="assets/icons/cancel.svg" alt="Cancel Icon" class="modal-close-icon rtl:mr-auto! rtl:ml-0!"
            (click)="close()" />
    </div>


    <!-- Form -->
    <form [formGroup]="rejectForm" class="space-y-4 text-start mt-6" (ngSubmit)="submitForm()">
        <!-- Rejection reason Field -->
        <app-input-field type="text" label="{{ 'USER_MANAGEMENT.REJECTION_REASON' | translate }}"
            placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" [control]="reasonControl"></app-input-field>

        <!-- Continue Button -->
        <app-button [text]="'USER_MANAGEMENT.REJECT_NOW' | translate" type="submit" variant="primary" size="lg"
            extraClass="mt-6" [disabled]="rejectForm.invalid"></app-button>
    </form>
</div>